import { mapState } from "vuex"

export const permissionsMix = {
  computed: {
    ...mapState('permissions', ['userPermissions', 'ignore'])
  },

  methods: {
    // a user can use this.$can('editVehicle') for example, to 
    $can(action) {
      if(this.ignore == 1) {
        return false
      }

      if(this.ignore == 2) {
        return true
      }

      // the user can refer to the mapped permission name or value returned by the api
      return !!this.userPermissions[action]
    }
  }
}